var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGoBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.84579 0.157234C9.14128 0.400898 9.18528 0.840398 8.94406 1.13889L2.34695 7.30233H19.3093C19.6908 7.30233 20 7.61469 20 8C20 8.38531 19.6908 8.69767 19.3093 8.69767H2.34695L8.94406 14.8611C9.18528 15.1596 9.14128 15.5991 8.84579 15.8428C8.5503 16.0864 8.11521 16.042 7.87399 15.7435L0 8L7.87399 0.256502C8.11521 -0.0419855 8.5503 -0.0864293 8.84579 0.157234Z",
    fill: "#051766"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGoBack);
export default __webpack_public_path__ + "static/media/icon__go_back.72daa57812850557cdc41d9f58e8db2c.svg";
export { ForwardRef as ReactComponent };